export const withIAS = iasPubId => ({
  display,
  iasPetTimeout = 2000,
}) => {
  if (typeof window !== 'undefined' && window.__iasPET) {
    // Set up IAS pet.js
    const __iasPET = window.__iasPET || {};
    __iasPET.queue = __iasPET.queue || [];
    __iasPET.pubId = iasPubId;

    // this is the maximum amount of time in milliseconds to wait
    // for a PET response before requesting ads without PET data.
    // IAS recommends starting at 2 seconds
    // when testing and adjusting downwards as appropriate.
    // remember to replace 'requestAds' below with the
    // function you use to request ads from DFP.
    const __iasPETTimeoutRequestAds = setTimeout(display, iasPetTimeout);

    // this function is called when a PET response is received. it
    // sets the targeting data for DFP and request ads
    // remember to replace requestAds() with the function you use for requesting
    // ads from DFP
    const iasDataHandler = () => {
      clearTimeout(__iasPETTimeoutRequestAds);
      __iasPET.setTargetingForGPT();
      display();
    };

    if (window.googletag) {
      // make the PET request
      window.googletag.cmd.push(() => {
        // read the currently defined GPT ad slots for sending to the PET endpoint
        // defined all GPT ad slots before calling PET
        const gptSlots = window.googletag.pubads().getSlots();
        const iasPETSlots = [];
        for (let i = 0; i < gptSlots.length; i += 1) {
          const sizes = gptSlots[i].getSizes().map((size) => {
            if (size.getWidth && size.getHeight) return [size.getWidth(), size.getHeight()];
            return [1, 1];
          });

          iasPETSlots.push({
            adSlotId: gptSlots[i].getSlotElementId(),
            // size: can either be a single size (for example, [728, 90])
            // or an array of sizes (for example, [[728, 90], [970, 90]])
            size: sizes,
            adUnitPath: gptSlots[i].getAdUnitPath(),
          });
        }

        // make the request to PET. if your page makes multiple ad requests to DFP
        // (for example, lazily loaded ads, infinite scrolling pages, etc.), make
        // a request to PET before every request to DFP
        __iasPET.queue.push({
          adSlots: iasPETSlots,
          dataHandler: iasDataHandler,
        });
      });
    }
  }
};
